import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import * as mixpanel from "core/integrations/mixpanel";
import { colors } from "core/stylesheet";

const Item = styled(Link)`
  color: ${colors.brand};
  text-decoration: none;
`;

export default ({ id, backLink }) => (
  <Item
    className="f7 fw6"
    to={"/insiders/" + id + `?backLink=${backLink}`}
    key={id}
    id={id}
    onClick={() => {
      return mixpanel.trackEvent("view an insider profile");
    }}
  >
    View profile
  </Item>
);



// WEBPACK FOOTER //
// ./src/components/common/candidate/ViewProfile.js